function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.6
}, React.createElement("g", {
  id: "2.2b-\\u2013-System-Admin-\\u2013-Images-\\u2013-Categories-tab",
  transform: "translate(-333.000000, -222.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "folder",
  transform: "translate(333.000000, 222.000000)"
}, React.createElement("path", {
  d: "M20.1446384,3.08884047 L14.4588529,3.08884047 C13.0773067,3.08884047 11.9501247,1.99951586 11.9501247,0.653594771 C11.9501247,0.290486565 11.6508728,0 11.276808,0 L3.8553616,0 C1.73067332,0 0,1.67998063 0,3.74243525 L0,16.2575648 C0,18.3200194 1.73067332,20 3.8553616,20 L20.1446384,20 C22.2693267,20 24,18.3200194 24,16.2575648 L24,6.82643428 C24,4.76397967 22.2693267,3.08884047 20.1446384,3.08884047 Z M22.6533666,16.2527233 C22.6533666,17.593803 21.5311721,18.687969 20.1446384,18.687969 L3.8553616,18.687969 C2.47381546,18.687969 1.34663342,17.5986444 1.34663342,16.2527233 L1.34663342,3.74243525 C1.34663342,2.4013556 2.46882793,1.30718954 3.8553616,1.30718954 L10.6633416,1.30718954 C10.9825436,3.05979182 12.563591,4.39603002 14.4588529,4.39603002 L20.1446384,4.39603002 C21.5261845,4.39603002 22.6533666,5.48535464 22.6533666,6.83127572 L22.6533666,16.2527233 L22.6533666,16.2527233 Z",
  id: "Shape"
}))));

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder.f0cecd67.svg";
export { ForwardRef as ReactComponent };